import { BlogsCubit, IBlogsCubit } from "../blocs/blog/BlogsBloc";
import BlogsList from "./BlogsList";

const blogsCubit: IBlogsCubit = new BlogsCubit();
blogsCubit.getAllBlogs();

export function BlogsPage() {
    return <BlogsList
        title="Blogs"
        blogsCubit={blogsCubit}
        showCategories={true}
    />
}